/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Completed_SuccessfullyInputs */



/**
* | output |
* | --- |
* | "Work import completed successfully" |
*
* @param {Work_Order_Import_Completed_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_completed_successfully = /** @type {((inputs?: Work_Order_Import_Completed_SuccessfullyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Completed_SuccessfullyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation du travail terminée avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Arbeitsimport erfolgreich abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione del lavoro completata con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт работы успешно завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de trabajo completada con éxito")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("工作导入已成功完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作業のインポートが正常に完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्य आयात सफलतापूर्वक पूरा हुआ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de trabalho concluída com sucesso")
	return /** @type {LocalizedString} */ ("Work import completed successfully")
});